import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { UnloadedContainer } from '@core/models/general-types/general-types';
import { SubscriptionsCheckup } from '@core/models/interfaces/storage-data/subscriptions-checkup';
import { createFeature, createReducer, on } from '@ngrx/store';

import { SubscriptionsCheckupActions } from './subscriptions-checkup.actions';

export type SubscriptionsCheckupState = UnloadedContainer<SubscriptionsCheckup>;

export const initialSubscriptionsCheckupState: SubscriptionsCheckupState = {
  collection: [],
  object: null,
  metaData: null,
};

const subscriptionsCheckupReducer = createReducer(
  initialSubscriptionsCheckupState,
  on(AppGlobalActions.loadAppDataSuccess, (state, { globalState }) =>
    // R37. `...(globalState.subscriptionsCheckup ?? {})` produced a new state object even
    // when this container was not part of the response, so a one-container
    // load handed all 23 feature slices a new reference and nothing else.
    globalState.subscriptionsCheckup
      ? { ...state, ...globalState.subscriptionsCheckup }
      : state
  ),
  on(
    SubscriptionsCheckupActions.loadSubscriptionsCheckupSuccess,
    (state, { subscriptionsCheckup }) => ({
      ...state,
      ...subscriptionsCheckup,
    })
  )
);

export const subscriptionsCheckupFeature = createFeature({
  name: 'subscriptionsCheckup',
  reducer: subscriptionsCheckupReducer,
  extraSelectors: ({ selectSubscriptionsCheckupState }) => ({
    selectSubscriptionsCheckupState,
  }),
});
